import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogGeneral } from 'app/dialogs/DialogGeneral';
import { formatDate } from 'app/helpers/formatDate';
import { formatKennitala } from 'app/helpers/formatKennitala';
import { ExposedListPublicRegistryPersonsRes } from 'app/interfaces/responses/Exposed/exposedListPublicRegistryPersonsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';

export interface DialogThjodskraPersonDetailsData {
    data: ExposedListPublicRegistryPersonsRes;
}

@Component({
    selector: 'dialog-thjodskra-person-details',
    templateUrl: 'dialog-thjodskra-person-details.html',
    styleUrls: ['dialog-thjodskra-person-details.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DialogThjodskraPersonDetails extends DialogGeneral {
    constructor(
        public matDialogRef: MatDialogRef<DialogThjodskraPersonDetails>,
        public dialogRef: MatDialogRef<DialogThjodskraPersonDetails>,
        public dialog: MatDialog,
        public lsrauthService: LsrauthService,
        @Inject(MAT_DIALOG_DATA) public data: DialogThjodskraPersonDetailsData
    ) {
        super(dialogRef);
    }

    formatDate(d) {
        return formatDate(d, false);
    }

    formatKennitala(kt) {
        return formatKennitala(kt);
    }

    formatAddress() {
        let data = this.data?.data;
        if (!data) {
            return '';
        }

        let { address, postalCode, place } = data;

        if (postalCode || postalCode) {
            address = address + `, ${postalCode ? ' ' + postalCode + ' ' + place : ''}`;
        }

        return address;
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    onNoClickSkipHistory(): void {}
}
